import { render, staticRenderFns } from "./MoleculeEditionBillingAcademiesData.vue?vue&type=template&id=354b4ba4"
import script from "./MoleculeEditionBillingAcademiesData.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademiesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports